/*
  label: 列的名称
  prop: 对应数据中的字段名
  sortable: 是否可排序
  slotName: 自定义插槽
*/
// 图 8 9 10
import * as echarts from "echarts";
const column8 = [
  {
    label: "推送任务名称",
    prop: "topic",
    width: 300,
    align: "left"
  },
  {
    label: "推送目标数量",
    prop: "pushAuthorCount",
    width: 80
  },
  {
    label: "推送成功数量",
    prop: "pushSuccessCount",
    width: 80
  },
  {
    label: "送达率",
    prop: "pushSuccessPercent",
    width: 60
  },
  {
    label: "打开数",
    prop: "emailOPenCount",
    width: 60
  },
  {
    label: "唯一打开数",
    prop: "onlyEmailOPenCount",
    width: 90
  },
  {
    label: "打开率",
    prop: "emailOPenPercent",
    width: 60
  },
  {
    label: "推送时间",
    prop: "pushTime"
    // width: 150
  }
];
// 图13
const column13 = [
  {
    label: "学者来源",
    prop: "sourceName"
  },
  {
    label: "邮件推送量",
    prop: "successCount"
  },
  {
    label: "邮件阅读量",
    prop: "openAuthorCount"
  }
];
// 图24
const lineChart24 = function(id, data, name, arr, year) {
  name = name.map(item => {
    return item + "期";
  });
  var chartDom = document.getElementById(id);
  var myChart = echarts.init(chartDom);
  var option;

  option = {
    // title: {
    //   text: "Stacked Line"
    // },
    tooltip: {
      trigger: "item"
    },

    legend: {
      data: [`${year}年邮件阅读次数`, `${Number(year) - 1}年邮件阅读次数`]
    },
    legend: {
      // Try 'horizontal'
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true
    },
    xAxis: {
      type: "category",
      data: name,
      boundaryGap: true //双侧留白
    },
    yAxis: {
      type: "value",
      axisLine: { show: false } // 隐藏 y 轴线,
    },
    series: [
      {
        name: `${year}年邮件阅读次数`,
        type: "line",
        data: data,
        itemStyle: { normal: { label: { show: true } } }
      },
      {
        name: `${Number(year) - 1}年邮件阅读次数`,
        type: "line",
        data: arr,
        itemStyle: {
          normal: {
            label: {
              show: true
            }
          }
        }
      }
    ]
  };

  option && myChart.setOption(option);
};
// 图34 35
const circularChart34 = function(id, data, radius = "70%") {
  var chartDom = document.getElementById(id);
  var myChart = echarts.init(chartDom);
  let chartDataName = data.map((item) => item.name)
  var option;
  option = {
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b}"
    },
    legend: {
      type: 'scroll',
      orient: 'vertical',
      right: 10,
      top: 20,
      bottom: 20,
      data: chartDataName,
      formatter: function (name) {
        // Limit the text to 5 characters and add '...' if it's longer
        return name.length > 10 ? name.substring(0, 10) + '...' : name
      }
    },
    series: [
      {
        type: "pie",
        name: '',
        radius: "55%",
        center: ["40%", "50%"],
        data: data
      }
    ]
  };

  option && myChart.setOption(option);
};
// 图22 23
const colChart22 = function(id, title, yData, data) {
  var chartDom = document.getElementById(id);
  var myChart = echarts.init(chartDom);
  var option;
  option = {
    title: {
      text: title,
      textStyle: {
        color: "#4874CB" // 设置标题的颜色为 #4874CB
      },
      x: "center" // 设置标题居中
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true
    },
    xAxis: {
      type: "value",
      boundaryGap: [0, 0.01]
    },
    yAxis: {
      type: "category",
      data: yData,
      axisLabel: {
        formatter: function(value) {
          return value.length > 15 ? value.substring(0, 15) + "..." : value;
        }
      }
    },
    series: [
      {
        name: "被引次数",
        type: "bar",
        data: data,
        itemStyle: {
          color: "#4874CB" // 设置每一项的颜色为 #4874CB
        },
        label: {
          show: true,
          position: "right"
        },
        barCategoryGap: "30%", // 设置条形图不同类别之间的间距
        barGap: "10%" // 设置同一类别内部条形之间的间距
      }
    ]
  };
  option && myChart.setOption(option);
};
// 图41
const column41 = [
  {
    label: "期刊名称",
    prop: "platMagName",
    width: 200
  },
  {
    label: "年份",
    prop: "year"
  },
  {
    label: "刊期",
    prop: "magNumber"
  },
  {
    label: "文章标题",
    prop: "root_title",
    width: 350
  },
  {
    label: "被引次数",
    prop: "frequency"
  }
];

const column12 = [
  {
    label: "微网刊标题",
    prop: "sysTopic"
  },
  {
    label: "发布时间",
    prop: "sysCreated",
    notSortable: true,
    width: 180
  },
  {
    label: "年份",
    prop: "year",
    width: 50
  },
  {
    label: "刊期",
    prop: "issue",
    width: 50
  },
  {
    label: "微网刊访问次数",
    prop: "netWorkCount",
    width: 140
  }
  // {
  //   label: "文章阅读次数",
  //   prop: "articleCount",
  //   width: 120
  // },
  // {
  //   label: "访问用户数（已授权）",
  //   prop: "userCount",
  //   width: 160
  // }
];
// 图25
const colChart25 = function(id, titleArr, countArr, title) {
  if (!document.getElementById(id)) {
    return;
  }
  const myChart = echarts.init(document.getElementById(id));
  myChart.setOption(
    {
      title: {
        text: title,
        textStyle: {
          // color: "#4874CB" // 设置标题的颜色为 #4874CB
        },
        x: "center" // 设置标题居中
      },
      color: "#0070C0",
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999"
          }
        }
      },
      xAxis: [
        {
          type: "category",
          data: titleArr,
          axisPointer: {
            type: "shadow"
          },
          axisLabel: {
            rotate: 30
            // formatter: function(value) {
            //   var res = value;
            //   if (res.length > 12) {
            //     res = res.substring(0, 12) + "..";
            //   }
            //   return res;
            // }
          }
        }
      ],
      grid: {
        left: "10%",
        bottom: "20%",
        top: "10%"
      },
      yAxis: [
        {
          type: "value",
          minInterval: 1
        }
      ],
      series: [
        {
          name: "数量",
          type: "bar",
          data: countArr,
          label: {
            show: true,
            position: "top"
          },
          barWidth: 20
        }
      ]
    },
    true
  );
};

// 推送前后单篇文章阅读情况echarts图
const colChart16 = function(id, data) {
  if (!document.getElementById(id)) {
    return;
  }
  console.log(data, "书23");
  const myChart = echarts.init(document.getElementById(id));
  const titleArr = [];
  const startVisitCountArr = [];
  const endVisitCountArr = [];
  const networkStartVisitCountArr = [];
  let XbarWidth = null;
  if (data && data.pushArticleVisitMapList.length > 0) {
    data.pushArticleVisitMapList.map(item => {
      item.title = item.title.replace(/<[^>]+>/g, "");
      titleArr.push(item.title);
      startVisitCountArr.push(item.startVisitCount || 0);
      endVisitCountArr.push(item.endVisitCount || 0);
      networkStartVisitCountArr.push(item.networkStartVisitCount || 0);
    });
  }
  let networkStartVisitLegend = false;
  let startVisitLegend = false;
  let endVisitLegend = false;

  networkStartVisitCountArr.map(item => {
    if (item !== 0) {
      networkStartVisitLegend = true;
    }
  });
  startVisitCountArr.map(item => {
    if (item !== 0) {
      startVisitLegend = true;
    }
  });
  endVisitCountArr.map(item => {
    if (item !== 0) {
      endVisitLegend = true;
    }
  });
  XbarWidth = titleArr.length >= 15 ? "" : 20;
  let _this = this;
  myChart.setOption(
    {
      color: ["#65A085", "#BBE0E3", "#265cca"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999"
          }
        }
      },
      legend: {
        orient: "vertical",
        left: "center",
        bottom: "bottom",
        data: ["微网刊发布前", "邮件推送前", "当前阅读"],
        selected: {
          微网刊发布前: networkStartVisitLegend,
          邮件推送前: startVisitLegend,
          当前阅读: endVisitLegend
        }
      },
      xAxis: [
        {
          type: "category",
          data: titleArr,
          axisPointer: {
            type: "shadow"
          },
          axisLabel: {
            rotate: 30,
            formatter: value => {
              var res = value;
              if (res.length > 6) {
                res = res.substring(0, 6) + "..";
              }
              return res;
            }
          }
        }
      ],
      grid: {
        left: "10%",
        bottom: "20%",
        top: "4%"
      },
      yAxis: [
        {
          type: "value",
          minInterval: 1
        }
      ],
      series: [
        {
          name: "微网刊发布前",
          type: "bar",
          data: networkStartVisitCountArr,
          barWidth: XbarWidth,
          barMaxWidth: 20,
          itemStyle: {
            normal: {
              label: {
                show: true, // 开启显示
                position: "top", // 在上方显示
                textStyle: {
                  // 数值样式
                  color: "black",
                  fontSize: 12
                }
              }
            }
          }
        },
        {
          name: "邮件推送前",
          type: "bar",
          data: startVisitCountArr,
          barWidth: XbarWidth,
          barMaxWidth: 20,
          itemStyle: {
            normal: {
              label: {
                show: true, // 开启显示
                position: "top", // 在上方显示
                textStyle: {
                  // 数值样式
                  color: "black",
                  fontSize: 12
                }
              }
            }
          }
        },
        {
          name: "当前阅读",
          type: "bar",
          data: endVisitCountArr,
          barWidth: XbarWidth,
          barMaxWidth: 20,
          itemStyle: {
            normal: {
              label: {
                show: true, // 开启显示
                position: "top", // 在上方显示
                textStyle: {
                  // 数值样式
                  color: "black",
                  fontSize: 12
                }
              }
            }
          }
        }
      ]
    },
    true
  );
};

// 推送前后单篇文章阅读情况echarts图
const colChart17 = function(id, data) {
  if (!document.getElementById(id)) {
    return;
  }
  const myChart = echarts.init(document.getElementById(id));
  const titleArr = [];
  const earliestSumVisitCountArr = [];
  const latestSumVisitCountArr = [];
  if (data && data.length > 0) {
    data.map(item => {
      if (item) {
        item.title = item.issue ? "第" + item.issue + "期" : "";
        titleArr.push(item.title);
        earliestSumVisitCountArr.push(item.earliestSumVisitCount || 0);
        latestSumVisitCountArr.push(item.latestSumVisitCount || 0);
      }
    });
  }
  myChart.setOption(
    {
      color: ["#91CC75", "#5470C6"],
      backgroundColor: "#F5F7FD",
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999"
          }
        }
      },
      legend: {
        top: "3%",
        data: ["传播前", "传播后"]
      },
      xAxis: [
        {
          type: "category",
          data: titleArr,
          axisPointer: {
            type: "shadow"
          }
        }
      ],
      grid: {
        left: "15%",
        bottom: "15%",
        top: "12%"
      },
      yAxis: [
        {
          type: "value",
          minInterval: 1
        }
      ],
      series: [
        {
          name: "传播前",
          type: "bar",
          barMaxWidth: 30,
          data: earliestSumVisitCountArr,
          itemStyle: {
            normal: {
              label: {
                show: true, // 开启显示
                position: "top", // 在上方显示
                textStyle: {
                  // 数值样式
                  color: "black",
                  fontSize: 12
                }
              }
            }
          }
        },
        {
          name: "传播后",
          type: "bar",
          barMaxWidth: 30,
          data: latestSumVisitCountArr,
          itemStyle: {
            normal: {
              label: {
                show: true, // 开启显示
                position: "top", // 在上方显示
                textStyle: {
                  // 数值样式
                  color: "black",
                  fontSize: 12
                }
              }
            }
          }
        }
      ]
    },
    true
  );
};
const column20 = [
  {
    label: "推送文章标题",
    prop: "title"
  },
  {
    label: "年份",
    prop: "year",
    width: 50
  },
  {
    label: "刊期",
    prop: "magNumber",
    width: 50
  },
  {
    label: "推送邮件标题",
    prop: "topic"
  },
  {
    label: "被引次数",
    prop: "citingTimes",
    width: 80
  }
];
const column15 = [
  {
    label: "文献标题",
    prop: "title",
    align: "left",
    width: 300
  },
  {
    label: "作者",
    prop: "authors",
    align: "left"
  },
  {
    label: "关键词",
    prop: "keywords",
    align: "left"
  },
  {
    label: "阅读量（引流）",
    prop: "wechatAndEmailCount",
    width: 120
  }
];
const column19 = [
  {
    label: "刊期",
    prop: "yearIssueText",
    width: 100
  },
  {
    label: "被引文献",
    prop: "root_title"
  },
  {
    label: "被引次数",
    prop: "frequency",
    width: 80
  }
];
const column30 = [
  {
    label: "地区",
    prop: "territory"
  },
  {
    label: "人数",
    prop: "count"
  },
  {
    label: "占比",
    prop: "proportion"
  }
];

// 图32
const lineChart32 = function(id, data) {
  console.log(data, "图32");
  var chartDom = document.getElementById(id);
  var myChart = echarts.init(chartDom);
  var option;
  let name = data.map(item => item.year + "年");
  option = {
    // title: {
    //   text: "Stacked Line"
    // },
    tooltip: {
      trigger: "item"
    },

    legend: {
      data: [`复合影响因子`, `综合影响因子`]
    },
    legend: {
      // Try 'horizontal'
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true
    },
    xAxis: {
      type: "category",
      data: name,
      boundaryGap: true //双侧留白
    },
    yAxis: {
      type: "value",
      axisLine: { show: false } // 隐藏 y 轴线,
    },
    series: [
      {
        name: "复合影响因子",
        type: "line",
        stack: "Total",
        data: data.map(item => item.compoundInfluenceFactor),
        itemStyle: { normal: { label: { show: true } } }
      },
      {
        name: "综合影响因子",
        type: "line",
        stack: "Total",
        data: data.map(item => item.comprehensiveInfluenceFactor),
        itemStyle: { normal: { label: { show: true } } }
      }
    ]
  };

  option && myChart.setOption(option);
};

// 图36
const lineChart36 = function(id, data) {
  console.log(data, "图36");
  var chartDom = document.getElementById(id);
  var myChart = echarts.init(chartDom);
  var option;
  let name = data.map(item => item.year + "年");
  option = {
    // title: {
    //   text: "Stacked Line"
    // },
    tooltip: {
      trigger: "item"
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true
    },
    xAxis: {
      type: "category",
      data: name,
      boundaryGap: true, //双侧留白
      axisLabel: {
        show: true, // 显示 X 轴标签
        rotate: 30 // 标签旋转角度，可以根据需要调整
      },
      axisPointer: {
        show: true, // 显示 X 轴指示器
        type: "shadow" // 指示器类型
      }
    },
    yAxis: {
      type: "value",
      axisLine: { show: false } // 隐藏 y 轴线,
    },
    series: [
      {
        // name: '复合影响因子',
        type: "line",
        stack: "Total",
        data: data.map(item => item.count),
        itemStyle: { normal: { label: { show: true } } }
      }
    ]
  };

  option && myChart.setOption(option);
};
export {
  column8,
  column13,
  lineChart24,
  circularChart34,
  colChart22,
  column41,
  column12,
  colChart25,
  colChart16,
  colChart17,
  column20,
  column15,
  column19,
  column30,
  lineChart32,
  lineChart36
};
